import React, { useEffect, useState, useRef } from "react";
import { all_routes } from "../router/all_routes";
import Breadcrumb from "../../core/common/Breadcrumb/breadcrumb";
import Sidebar from "../../core/common/sidebar/sidebar";
import axios from "axios";
import { BsPaperclip } from "react-icons/bs";

type TicketDTO = {
    id: number;
    assunto: string;
    status: string;
    criadoEm: string;
    naoLidas: number;
};

type TicketMessageDTO = {
    id: number;
    conteudo: string;
    usuarioNome: string;
    arquivoId: number | null;
    arquivoUrl: string | null;
    enviadoEm: string;
};

const Support = () => {
    const routes = all_routes;
    const BASE_URL = process.env.REACT_APP_API_URL;
    const token = localStorage.getItem("token");

    const headers = { Authorization: `Bearer ${token}` };

    const [tickets, setTickets] = useState<TicketDTO[]>([]);
    const [selectedTicket, setSelectedTicket] = useState<TicketDTO | null>(null);
    const [messages, setMessages] = useState<TicketMessageDTO[]>([]);
    const [newTicketAssunto, setNewTicketAssunto] = useState("");
    const [newTicketMessage, setNewTicketMessage] = useState("");
    const [newTicketFile, setNewTicketFile] = useState<File | null>(null);
    const [newMessage, setNewMessage] = useState("");
    const [file, setFile] = useState<File | null>(null);
    const [ticketPreviewFile, setTicketPreviewFile] = useState<string | null>(null);
    const [messagePreviewFile, setMessagePreviewFile] = useState<string | null>(null);

    const [showCreateForm, setShowCreateForm] = useState(false);

    const messageEndRef = useRef<HTMLDivElement>(null);

    const fetchTickets = async () => {
        try {
            const res = await axios.get(`${BASE_URL}/support/tickets`, { headers });
            setTickets(res.data);
        } catch (err) {
            console.error("Erro ao buscar tickets:", err);
        }
    };

    const fetchMessages = async (ticketId: number) => {
        try {
            const res = await axios.get(`${BASE_URL}/support/ticket/${ticketId}/messages`, { headers });
            setMessages(res.data);
            scrollToBottom();
        } catch (err) {
            console.error("Erro ao buscar mensagens:", err);
        }
    };

    const createTicket = async () => {
        if (!newTicketAssunto) return;

        try {
            let arquivoId: number | null = null;

            // 1️⃣ Upload do arquivo, se existir
            if (newTicketFile) {
                const uploadData = new FormData();
                uploadData.append("file", newTicketFile);

                const uploadRes = await axios.post(`${BASE_URL}/uploads`, uploadData, { headers });
                arquivoId = uploadRes.data.id; // pega o ID do arquivo
            }

            // 2️⃣ Cria o ticket apenas com assunto
            const formDataAssunto = new FormData();
            formDataAssunto.append("assunto", newTicketAssunto);

            const res = await axios.post(`${BASE_URL}/support/ticket`, formDataAssunto, { headers });
            const ticket = res.data;

            // 3️⃣ Se tiver mensagem inicial, envia usando arquivoId
            if (newTicketMessage) {
                const msgData = new FormData();
                msgData.append("conteudo", newTicketMessage);
                if (arquivoId) msgData.append("arquivoId", arquivoId.toString());

                await axios.post(`${BASE_URL}/support/ticket/${ticket.id}/message`, msgData, { headers });
            }

            // Resetar estados
            setNewTicketAssunto("");
            setNewTicketMessage("");
            setNewTicketFile(null);
            setShowCreateForm(false);
            fetchTickets();
        } catch (err) {
            console.error("Erro ao criar ticket:", err);
        }
    };


    const sendMessage = async () => {
        if (!selectedTicket || !newMessage) return;

        try {
            let arquivoId: number | null = null;

            if (file) {
                const uploadData = new FormData();
                uploadData.append("file", file);

                const uploadRes = await axios.post(`${BASE_URL}/uploads`, uploadData, { headers });
                arquivoId = uploadRes.data.id;
            }

            const msgData = new FormData();
            msgData.append("conteudo", newMessage);
            if (arquivoId) msgData.append("arquivoId", arquivoId.toString());

            await axios.post(`${BASE_URL}/support/ticket/${selectedTicket.id}/message`, msgData, { headers });

            setNewMessage("");
            setFile(null);
            fetchMessages(selectedTicket.id);
        } catch (err) {
            console.error("Erro ao enviar mensagem:", err);
        }
    };

    const scrollToBottom = () => {
        messageEndRef.current?.scrollIntoView({ behavior: "smooth" });
    };

    useEffect(() => {
        fetchTickets();
    }, []);
    useEffect(() => {
        const token = localStorage.getItem("token");
        if (!token) return;

        axios.get(`${BASE_URL}/support/tickets/unread-by-ticket`, {
            headers: { Authorization: `Bearer ${token}` },
        })
            .then(res => {
            })
            .catch(err => console.error("Erro ao buscar mensagens não lidas por ticket:", err));
    }, []);


    const breadcrumbs = [
        { label: "Support", link: routes.home1, active: false },
        { label: "Support", active: true },
    ];

    return (
        <div>
            <Breadcrumb title="Support" breadcrumbs={breadcrumbs} backgroundClass="breadcrumb-bg-01" />

            <div className="content">
                <div className="container">
                    <div className="row">
                        <div className="col-xl-3 col-lg-4">
                            <Sidebar />
                        </div>

                        <div className="col-xl-9 col-lg-8">
                            {/* Criar novo ticket */}
                            <div className="card shadow-sm mb-3">
                                <div className="card-header d-flex align-items-center justify-content-between">
                                    <h6 className="mb-0">Support Tickets</h6>
                                </div>
                                <div className="card-body">
                                    {!showCreateForm ? (
                                        <button
                                            className="btn btn-primary w-100"
                                            onClick={() => setShowCreateForm(true)}
                                        >
                                            Criar Novo Ticket
                                        </button>
                                    ) : (
                                        <div className="d-flex flex-column gap-2">
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Assunto do ticket"
                                                value={newTicketAssunto}
                                                onChange={(e) => setNewTicketAssunto(e.target.value)}
                                            />
                                            <textarea
                                                className="form-control"
                                                placeholder="Mensagem inicial"
                                                value={newTicketMessage}
                                                onChange={(e) => setNewTicketMessage(e.target.value)}
                                            />
                                            <input
                                                type="file"
                                                className="form-control"
                                                onChange={(e) => {
                                                    const file = e.target.files?.[0] || null;
                                                    setNewTicketFile(file);
                                                    setTicketPreviewFile(file ? URL.createObjectURL(file) : null);
                                                }}
                                            />

                                            {/* Preview da imagem */}
                                            {ticketPreviewFile && (
                                                <div style={{ marginTop: "5px", display: "flex", alignItems: "center", gap: "0.5rem" }}>
                                                    <img
                                                        src={ticketPreviewFile}
                                                        alt="Pré-visualização"
                                                        style={{
                                                            width: "60px",       // largura fixa da thumbnail
                                                            height: "60px",      // altura fixa da thumbnail
                                                            objectFit: "cover",  // mantém proporção e corta excesso
                                                            borderRadius: "4px",
                                                            border: "1px solid #ccc"
                                                        }}
                                                    />
                                                </div>
                                            )}

                                            <div className="d-flex gap-2">
                                                <button
                                                    className="btn btn-success flex-grow-1"
                                                    onClick={createTicket}
                                                >
                                                    Confirmar
                                                </button>
                                                <button
                                                    className="btn btn-secondary flex-grow-1"
                                                    onClick={() => {
                                                        setShowCreateForm(false);
                                                        setNewTicketAssunto("");
                                                        setNewTicketMessage("");
                                                        setNewTicketFile(null);
                                                        setTicketPreviewFile(null);
                                                    }}
                                                >
                                                    Cancelar
                                                </button>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>

                            {/* Conteúdo principal com 2 colunas */}
                            <div className="d-flex gap-3">
                                {/* Coluna esquerda - lista de tickets */}
                                {/* 📂 Coluna esquerda - lista de tickets */}
                                <div
                                    className="flex-shrink-0 p-3 border rounded-2"
                                    style={{
                                        width: "260px",
                                        maxHeight: "500px",
                                        overflowY: "auto",
                                        backgroundColor: "#f8f9fb",
                                    }}
                                >
                                    {tickets.length === 0 ? (
                                        <p className="text-muted text-center mt-4">Nenhum ticket criado ainda.</p>
                                    ) : (
                                        <div className="d-flex flex-column gap-2">
                                            {tickets.map((t) => (
                                                <div
                                                    key={t.id}
                                                    className={`d-flex flex-column p-2 rounded shadow-sm cursor-pointer border 
                                                    ${selectedTicket?.id === t.id
                                                            ? "border-primary bg-white"
                                                            : "border-light bg-light"
                                                        }`}
                                                    style={{
                                                        transition: "all 0.2s ease",
                                                    }}
                                                    onClick={() => {
                                                        setSelectedTicket(t);
                                                        fetchMessages(t.id);
                                                    }}
                                                    onMouseEnter={(e) => {
                                                        (e.currentTarget as HTMLDivElement).style.boxShadow =
                                                            "0 2px 6px rgba(0,0,0,0.08)";
                                                    }}
                                                    onMouseLeave={(e) => {
                                                        (e.currentTarget as HTMLDivElement).style.boxShadow = "none";
                                                    }}
                                                >
                                                    {/* Assunto e badge */}
                                                    <div className="d-flex justify-content-between align-items-center">
                                                        <strong
                                                            style={{
                                                                fontSize: "14px",
                                                                color: selectedTicket?.id === t.id ? "#0d6efd" : "#212529",
                                                            }}
                                                        >
                                                            {t.assunto}
                                                        </strong>
                                                        {t.naoLidas > 0 && (
                                                            <span
                                                                className="badge rounded-pill bg-danger"
                                                                style={{ fontSize: "11px" }}
                                                            >
                                                                {t.naoLidas}
                                                            </span>
                                                        )}
                                                    </div>

                                                    {/* Status */}
                                                    <div
                                                        className="text-muted mt-1"
                                                        style={{ fontSize: "12px", lineHeight: "14px" }}
                                                    >
                                                        Status:{" "}
                                                        <span
                                                            className={`fw-semibold ${t.status === "ABERTO"
                                                                ? "text-success"
                                                                : t.status === "PENDENTE"
                                                                    ? "text-warning"
                                                                    : "text-secondary"
                                                                }`}
                                                        >
                                                            {t.status}
                                                        </span>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>

                                {/* Coluna direita - chat */}
                                {selectedTicket && (
                                    <div className="flex-grow-1 d-flex flex-column">
                                        <div className="card shadow-sm d-flex flex-column" style={{ height: "650px" /* aumentei altura total */ }}>
                                            <div className="card-header">
                                                <h6 className="mb-0">{selectedTicket.assunto}</h6>
                                            </div>

                                            {/* Mensagens */}
                                            <div
                                                className="flex-grow-1 overflow-auto p-3"
                                                style={{ backgroundColor: "#f5f5f5" }}
                                            >
                                                {messages.map((m) => (
                                                    <div
                                                        key={m.id}
                                                        className={`d-flex mb-2 ${m.usuarioNome === "Você" ? "justify-content-end" : "justify-content-start"}`}
                                                    >
                                                        <div
                                                            className={`p-2 rounded ${m.usuarioNome === "Você" ? "bg-primary text-white" : "bg-white text-dark"} shadow-sm`}
                                                            style={{ maxWidth: "75%" }}
                                                        >
                                                            <div className="d-flex justify-content-between mb-1">
                                                                <strong>{m.usuarioNome}</strong>
                                                                <span className="text-muted" style={{ fontSize: "10px" }}>
                                                                    {new Date(m.enviadoEm).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                                                                </span>
                                                            </div>
                                                            <p className="mb-1">{m.conteudo}</p>
                                                            {m.arquivoUrl && (
                                                                <img
                                                                    src={`${BASE_URL}${m.arquivoUrl}`}
                                                                    alt="Anexo"
                                                                    style={{ maxWidth: "100%", borderRadius: "4px", marginTop: "5px" }}
                                                                />
                                                            )}
                                                        </div>
                                                    </div>
                                                ))}
                                                <div ref={messageEndRef} />
                                            </div>

                                            {/* Input + preview */}
                                            <div className="card-footer d-flex flex-column gap-2">
                                                <div style={{ position: "relative", display: "flex", alignItems: "center" }}>
                                                    {/* Input de texto com ícone dentro */}
                                                    <div style={{ position: "relative", flexGrow: 1 }}>
                                                        <textarea
                                                            rows={2}
                                                            className="form-control pe-5"
                                                            placeholder="Digite sua mensagem..."
                                                            value={newMessage}
                                                            onChange={(e) => setNewMessage(e.target.value)}
                                                        />
                                                        <label
                                                            htmlFor="fileInput"
                                                            style={{
                                                                position: "absolute",
                                                                right: "10px",
                                                                top: "50%",
                                                                transform: "translateY(-50%)",
                                                                cursor: "pointer",
                                                                fontSize: "1.5rem",
                                                                color: "#6c757d"
                                                            }}
                                                            title="Inserir arquivo"
                                                        >
                                                            <BsPaperclip />
                                                        </label>
                                                        <input
                                                            id="fileInput"
                                                            type="file"
                                                            style={{ display: "none" }}
                                                            onChange={(e) => {
                                                                const file = e.target.files?.[0] || null;
                                                                setFile(file);
                                                                setMessagePreviewFile(file ? URL.createObjectURL(file) : null);
                                                            }}
                                                        />
                                                    </div>

                                                    {/* Botão enviar separado */}
                                                    <button className="btn btn-primary ms-2" onClick={sendMessage}>
                                                        Enviar
                                                    </button>
                                                </div>

                                                {/* Preview da imagem */}
                                                {messagePreviewFile && (
                                                    <img
                                                        src={messagePreviewFile}
                                                        alt="Pré-visualização"
                                                        style={{
                                                            width: "80px",
                                                            height: "80px",
                                                            objectFit: "cover",
                                                            borderRadius: "4px"
                                                        }}
                                                    />
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Support;
